var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlacedDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008668"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 41097",
    d: "M32.3043 32.9463H1V38.0018C1 39.6587 2.34315 41.0018 4 41.0018H29.3043C30.9612 41.0018 32.3043 39.6587 32.3043 38.0018V32.9463Z",
    fill: "#82BD54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250852",
    d: "M37.5202 15.751L23.6072 29.2665H20.1289L20.9985 25.7883L35.7811 11.4404L38.8246 14.4839L37.5202 15.751ZM37.5202 15.751L38.8246 17.0926L34.9115 21.0056",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250849",
    d: "M17.5203 29.7021H7.95508",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250850",
    d: "M17.5203 22.7363H7.95508",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250851",
    d: "M21.8681 15.7803H7.95508",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 41096",
    d: "M32.3043 10.5672V4.00195C32.3043 2.3451 30.9612 1.00195 29.3043 1.00195H4C2.34315 1.00195 1 2.3451 1 4.00195V38.002C1 39.6588 2.34315 41.002 4 41.002H29.3043C30.9612 41.002 32.3043 39.6588 32.3043 38.002V28.828",
    stroke: "#383434",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlacedDone);
export default __webpack_public_path__ + "static/media/placed_done.885698b254ccd98ea025e3c6940ccaf9.svg";
export { ForwardRef as ReactComponent };